module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 41-f62cb21524f41f82a6442eaa0853b4a9.png";